import React, { useEffect, useState, useRef } from 'react';
import { useComponentConfig } from 'js/hooks/component/useComponentConfig';

import * as hooks from '../../hooks';
import * as helpers from '../../helpers';
import { TableItem } from './components/TableItem';
import { TABLE_ANIMATION_INTERVAL } from '../../constants';

import style from './Table.scss';

export const Table = () => {
    const { rowsAmount = 3 } = useComponentConfig();
    const allWinners = hooks.useTopWinners();
    const [tableHeight, setTableHeight] = useState(0);
    const [topWinners, setTopWinners] = useState(helpers.getWinnersSelection({
        rowsAmount, startIndex: 0, allWinners
    }));
    const tableItemRef = useRef(null);
    const tableRef = hooks.useUpdateTableHeight(topWinners.length, tableItemRef, setTableHeight);

    useEffect(() => {
        if (!rowsAmount) {
            return;
        }

        let startIndex = 1;

        const intervalId = setInterval(() => {
            const winners = helpers.getWinnersSelection({
                rowsAmount, startIndex, allWinners
            });

            setTopWinners(winners);
            startIndex++;
        }, TABLE_ANIMATION_INTERVAL);

        return () => clearInterval(intervalId);
    }, [allWinners, rowsAmount]);

    return (
        <div ref={tableRef} className={`${style.tableWrapper} cms-top-winners-table`} style={{ minHeight: `${tableHeight}px` }}>
            {topWinners.map((topWinner, index) => (
                <TableItem
                    {...topWinner}
                    key={topWinner.id}
                    className={style.topWinner}
                    tableItemRef={index === 0 ? tableItemRef : null}
                />
            ))}
        </div>
    );
};
